module.exports = __webpack_public_path__ + "img/core-bg3.0f7ead4f.jpg";